import { render, staticRenderFns } from "./ConsolePanel.vue?vue&type=template&id=636f6970&scoped=true&"
import script from "./ConsolePanel.vue?vue&type=script&lang=js&"
export * from "./ConsolePanel.vue?vue&type=script&lang=js&"
import style0 from "./ConsolePanel.vue?vue&type=style&index=0&id=636f6970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f6970",
  null
  
)

export default component.exports